<template>
  <div class="container mt-5 mb-5">
    <h3>Alerts</h3>
    <div class="alert alert-primary" role="alert">
      A simple primary alert—check it out!
    </div>
    <div class="alert alert-secondary" role="alert">
      A simple secondary alert—check it out!
    </div>
    <div class="alert alert-success" role="alert">
      A simple success alert—check it out!
    </div>
    <div class="alert alert-danger" role="alert">
      A simple danger alert—check it out!
    </div>
    <div class="alert alert-warning" role="alert">
      A simple warning alert—check it out!
    </div>
    <div class="alert alert-info" role="alert">
      A simple info alert—check it out!
    </div>
    <div class="alert alert-light" role="alert">
      A simple light alert—check it out!
    </div>
    <div class="alert alert-dark" role="alert">
      A simple dark alert—check it out!
    </div>

    <h3 class="mt-5">Badges</h3>
    <span class="badge badge-primary mr-2">Primary</span>
    <span class="badge badge-secondary mr-2">Secondary</span>
    <span class="badge badge-success mr-2">Success</span>
    <span class="badge badge-danger mr-2">Danger</span>
    <span class="badge badge-warning mr-2">Warning</span>
    <span class="badge badge-info mr-2">Info</span>
    <span class="badge badge-light mr-2">Light</span>
    <span class="badge badge-dark mr-2">Dark</span>

    <h3 class="mt-5">Breadcrumb</h3>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">Home</a></li>
        <li class="breadcrumb-item"><a href="#">Library</a></li>
        <li class="breadcrumb-item active" aria-current="page">Data</li>
      </ol>
    </nav>

    <h3 class="mt-5">Buttons</h3>
    <button type="button" class="btn btn-primarym mr-2">Primary</button>
    <button type="button" class="btn btn-secondary mr-2">Secondary</button>
    <button type="button" class="btn btn-success mr-2">Success</button>
    <button type="button" class="btn btn-danger mr-2">Danger</button>
    <button type="button" class="btn btn-warning mr-2">Warning</button>
    <button type="button" class="btn btn-info mr-2">Info</button>
    <button type="button" class="btn btn-light mr-2">Light</button>
    <button type="button" class="btn btn-dark mr-2">Dark</button>
    <button type="button" class="btn btn-link mr-2">Link</button>

    <h3 class="mt-5">Card</h3>
    <div class="card">
      <div class="card-body">
        <h5>Card title</h5>
        Card content
      </div>
    </div>

    <h3 class="mt-5">Card with menu</h3>
    <div class="card">
      <div class="card-header">
        <h5 class="float-left mt-3">
          Card title
        </h5>
      </div>
      <div class="row no-gutters">
        <div class="col-sm-2 card-menu">
          <div class="card-body text-dark">
            <p class="mt-2">
              {{ $t('activities.integrity_check.integrity_check_label') }}
            </p>
            <br>
            <p>{{ $t('activities.integrity_check.ic_label') }}</p>
            <br>
            <p>{{ $t('activities.integrity_check.description_label') }}</p>
            <br>
          </div>
        </div>
        <div class="col-sm-10">
          <div class="card-body">

          </div>
        </div>

      </div>
    </div>

    <h3 class="mt-5">Modal</h3>
    <div class="modal" tabindex="-1" role="dialog" style="position: unset; display: block;">
      <div class="modal-dialog mt-1" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Modal body text goes here.</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-success">Save changes</button>
          </div>
        </div>
      </div>
    </div>

    <h3 class="mt-5">Pagination</h3>
    <b-pagination
        class=""
        v-model="currentPage"
        total-rows="10"
        per-page="10"
        aria-controls="my-table"
        limit="1"
    >
      <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
      <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
      <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
      <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
      <div slot="ellipsis-text">
        <b-spinner small type="grow"></b-spinner>
        <b-spinner small type="grow"></b-spinner>
        <b-spinner small type="grow"></b-spinner>
      </div>
      <span class="text-muted" slot="page" slot-scope="{ page, active }">
        <span v-if="active">10</span>
      </span>
    </b-pagination>

    <h3 class="mt-5">Tooltips</h3>
    <button type="button" class="btn btn-secondary mr-4" v-b-tooltip.hover.top title="Tooltip on top">
      Tooltip on top
    </button>
    <button type="button" class="btn btn-secondary mr-4" v-b-tooltip.hover.right title="Tooltip on right">
      Tooltip on right
    </button>
    <button type="button" class="btn btn-secondary mr-4" v-b-tooltip.hover.bottom title="Tooltip on bottom">
      Tooltip on bottom
    </button>
    <button type="button" class="btn btn-secondary mr-4" v-b-tooltip.hover.left title="Tooltip on left">
      Tooltip on left
    </button>

    <h3 class="mt-5">Headings</h3>
    <h1>h1. heading</h1>
    <h2>h2. heading</h2>
    <h3>h3. heading</h3>
    <h4>h4. heading</h4>
    <h5>h5. heading</h5>
    <h6>h6. heading</h6>

    <h3 class="mt-5">Table</h3>
    <div class="card">
      <div class="card-body">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">First</th>
              <th scope="col">Last</th>
              <th scope="col">Handle</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Mark</td>
              <td>Otto</td>
              <td>@mdo</td>
            </tr>
            <tr>
              <td>Jacob</td>
              <td>Thornton</td>
              <td>@fat</td>
            </tr>
            <tr>
              <td>Larry</td>
              <td>the Bird</td>
              <td>@twitter</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h3 class="mt-5">Tabs</h3>
    <div>
      <b-tabs content-class="mt-3">
        <b-tab title="First" active><p>I'm the first tab</p></b-tab>
        <b-tab title="Second"><p>I'm the second tab</p></b-tab>
        <b-tab title="Disabled" disabled><p>I'm a disabled tab!</p></b-tab>
      </b-tabs>
    </div>

    <h3 class="mt-3">Form</h3>
    <div class="card">

      <div class="card-body">
        <div class="form-centered">
          <b-form qid="create-s-form">
            <div class="form-container">
              <b-form-group>
                <label qid="create-s-name-label">
                  {{ $t('activities.create.name_label') }}
                </label>
                <b-form-input
                  type="text"
                  required
                  :placeholder="$t('activities.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-s-description-label">
                  {{ $t('activities.create.description_label') }}
                </label>
                <b-form-textarea
                  rows="6"
                  max-rows="6"
                  :placeholder="$t('activities.create.description_placeholder')"
                ></b-form-textarea>
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
              >
                {{ $t('activities.create.cancel') }}
              </b-button>
              <b-button class="mt-3 ml-3"
                        variant="success"
              >
                {{ $t('activities.create.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

  export default {
    name: 'Styleguide',
    data() {
      return {
        currentPage: 1
      };
    },
    components: {

    },
    methods: {

    },
    created() {

    }
  }

</script>
